import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
//import { ConnectedRouter } from 'react-router-redux';
import { BrowserRouter as Router } from "react-router-dom";
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
//import App from './App';
import FlightDetails from './containers/flightDetails'
import FlightSchedule from './containers/flightSchedule'
import registerServiceWorker from './registerServiceWorker';
import Routes from './routes';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
//const store = configureStore(history, initialState);
const store = configureStore(initialState);
const rootElement = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>    
    <Router>
      <Routes />
    </Router>
    {/* <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter> */}
  </Provider>,
  rootElement);

registerServiceWorker();